"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeAddress = exports.AddressSchema = exports.fakePhoto = exports.PhotoSchema = exports.fakePhoneNumber = exports.PhoneNumberSchema = exports.fakeEmail = exports.EmailSchema = void 0;
var zod_1 = require("zod");
var i18next_1 = require("i18next");
var ramda_1 = require("ramda");
var emailErrorMap = function (error, ctx) {
    switch (error.code) {
        case zod_1.z.ZodIssueCode.invalid_string:
            if (ctx.data === '') {
                return { message: (0, i18next_1.t)('ds.required') };
            }
            return { message: (0, i18next_1.t)('ds.email invalid') };
        default:
            return { message: ctx.defaultError };
    }
};
exports.EmailSchema = zod_1.z.object({
    value: zod_1.z.string({ errorMap: emailErrorMap }).email(),
    type: zod_1.z.enum(['work', 'home']),
    primary: zod_1.z.boolean(),
});
var fakeEmail = function (email) {
    if (email === void 0) { email = {}; }
    return (0, ramda_1.mergeDeepRight)({
        value: 'email@domain.com',
        type: 'work',
        primary: false,
    }, email);
};
exports.fakeEmail = fakeEmail;
exports.PhoneNumberSchema = zod_1.z
    .object({
    value: zod_1.z.string(),
    type: zod_1.z.enum(['work', 'mobile', 'home']),
    primary: zod_1.z.boolean(),
})
    .required();
var fakePhoneNumber = function (phoneNumber) {
    if (phoneNumber === void 0) { phoneNumber = {}; }
    return (0, ramda_1.mergeDeepRight)({
        value: '',
        type: 'work',
        primary: false,
    }, phoneNumber);
};
exports.fakePhoneNumber = fakePhoneNumber;
exports.PhotoSchema = zod_1.z.object({
    value: zod_1.z.string(),
    type: zod_1.z.enum(['photo', 'thumbnail']),
});
var fakePhoto = function (photo) {
    if (photo === void 0) { photo = {}; }
    return (0, ramda_1.mergeDeepRight)({
        value: '',
        type: 'photo',
    }, photo);
};
exports.fakePhoto = fakePhoto;
var addressErrorMap = function (error, ctx) {
    switch (error.code) {
        case zod_1.z.ZodIssueCode.invalid_string:
            return { message: (0, i18next_1.t)('ds.required') };
        default:
            return { message: ctx.defaultError };
    }
};
exports.AddressSchema = zod_1.z.object({
    streetAddress: zod_1.z.string({ errorMap: addressErrorMap }),
    locality: zod_1.z.string({ errorMap: addressErrorMap }),
    region: zod_1.z.string({ errorMap: addressErrorMap }),
    postalCode: zod_1.z.string({ errorMap: addressErrorMap }),
    country: zod_1.z.string({ errorMap: addressErrorMap }),
    formatted: zod_1.z.string(),
    type: zod_1.z.enum(['work', 'home']),
    primary: zod_1.z.preprocess(function (primary) { return !!primary; }, zod_1.z.boolean()),
});
var fakeAddress = function (address) {
    if (address === void 0) { address = {}; }
    return (0, ramda_1.mergeDeepRight)({
        streetAddress: 'streetAddress',
        locality: 'locality',
        region: 'region',
        postalCode: 'postalCode',
        country: 'country',
        formatted: 'formatted',
        type: 'work',
        primary: false,
    }, address);
};
exports.fakeAddress = fakeAddress;
//# sourceMappingURL=inputs.js.map